module.exports = __webpack_public_path__ + "img/login-bg.adf702fc.jpg";